var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent", staticStyle: { height: "calc(100vh - 50px)" } },
    [
      _c("dialogue", {
        attrs: {
          title: "Delete",
          paragraph:
            "Are you sure you want to delete Techdoc " + _vm.term + "?",
          button_names: ["Delete"],
          show: _vm.delete_dialogue
        },
        on: { dialogue: _vm.deleteTechdoc, cancel: _vm.cancelDelete }
      }),
      _vm._v(" "),
      _c("dialogue", {
        attrs: {
          title: "Saved",
          paragraph: "Techdoc " + _vm.term + " has been saved",
          button_names: ["Accept"],
          show: _vm.save_dialogue
        },
        on: { cancel: _vm.cancelSave }
      }),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          {
            staticClass: "scroll",
            staticStyle: {
              width: "30%",
              height: "calc(100vh - 75px)",
              float: "left"
            }
          },
          [
            _c("table", [
              _c("tr", [
                _vm._m(0),
                _vm._v(" "),
                _c("td", { staticStyle: { width: "90%" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filename,
                        expression: "filename"
                      }
                    ],
                    staticStyle: { width: "100%" },
                    domProps: { value: _vm.filename },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.filename = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _vm._m(1),
                _vm._v(" "),
                _c("td", [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.notes,
                        expression: "notes"
                      }
                    ],
                    staticStyle: {
                      width: "100%",
                      "min-height": "30px",
                      height: "60px",
                      "max-height": "125px"
                    },
                    domProps: { value: _vm.notes },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.notes = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "scroll",
            staticStyle: {
              width: "65%",
              height: "calc(100vh - 75px)",
              float: "right"
            }
          },
          [
            _c("techdoc", {
              ref: "doc",
              staticStyle: { width: "100%", height: "calc(95%)" },
              attrs: {
                id: parseInt(_vm.term),
                techdoc_id: _vm.term,
                pageid: _vm.pageid
              },
              on: { load: _vm.setData }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", [
          _vm.perms.includes("61")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.saveTechdoc()
                    }
                  }
                },
                [_vm._v("Save")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("61")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.deleteTechdocDialogue()
                    }
                  }
                },
                [_vm._v("Delete")]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("b", { staticStyle: { "white-space": "nowrap" } }, [
        _vm._v("File Name")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("b", { staticStyle: { "white-space": "nowrap" } }, [_vm._v("Notes")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fdca2b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fdca2b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/Edit_Techdocs.vue
// module id = 680
// module chunks = 0